import React from "react";
import "./OurMissionSection.css";
import { FaLightbulb, FaBookOpen, FaUsers, FaSeedling, FaStar } from "react-icons/fa";

const missionItems = [
  {
    icon: <FaLightbulb />,
    title: "Create",
    text: "meaningful content and experiences",
  },
  {
    icon: <FaBookOpen />,
    title: "Learn",
    text: "through shared knowledge and innovation",
  },
  {
    icon: <FaUsers />,
    title: "Collaborate",
    text: "across disciplines and communities",
  },
  {
    icon: <FaSeedling />,
    title: "Grow",
    text: "individuals and organizations",
  },
  {
    icon: <FaStar />,
    title: "Inspire",
    text: "lasting change in society",
  },
];

const OurMissionSection = () => {
  return (
    <section className="mission-section">
      <div className="container">

        <h2 className="mission-title">Our Mission</h2>

        <p className="mission-subtitle">
          Guided by the principles of <span>Ideas, Stories, Leadership, and Impact</span>, Ample House exists to:
        </p>

        <div className="mission-grid">
          {missionItems.map((item, index) => (
            <div key={index} className="mission-item">
              <div className="mission-icon">{item.icon}</div>
              <h3 className="mission-item-title">{item.title}</h3>
              <p className="mission-text">{item.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurMissionSection;